import { Option } from "@models/clients/option";

interface OptionsTableBindings {
  optionType: string;
  title: string;
  icon: string;
  onRefresh?: () => void;
}

class OptionsTableController implements angular.IOnInit {
  public options: Option[] = [];
  public loading = false;
  public readonly columns = Object.freeze([
    { key: 'displayName', label: 'Display Name', width: 'col-md-9' }
  ]);
  public displayColumns = false;
  public optionType: string;
  public title: string;
  public icon: string;
  public onRefresh?: () => void;
  public expanded = false;

  /** @ngInject */
  constructor(
    private clientCRMRepo: any,
    private $scope: angular.IScope
  ) {}

  async $onInit() {
    await this.loadOptions();
  }

  private async loadOptions() {
    try {
      this.loading = true;
      const response = await this.clientCRMRepo.getOptions(this.optionType);
      this.options = response.data as Option[];
    } catch (error) {
      console.error(`Error loading ${this.optionType} options:`, error);
      this.options = [];
    } finally {
      this.loading = false;
    }
  }

  public refresh() {
    this.loadOptions();
    if (this.onRefresh) {
      this.onRefresh();
    }
  }

  public toggleExpanded(): void {
    this.expanded = !this.expanded;
  }

  public getExpandIcon(): string {
    return this.expanded ? 'expand_less' : 'expand_more';
  }
}

export const optionsTable = {
  template: require("./options-table.html"),
  style: require("./options-table.scss"),
  controller: OptionsTableController,
  bindings: {
    optionType: '@',
    title: '@',
    icon: '@',
    onRefresh: '&?'
  }
};



// WEBPACK FOOTER //
// ./src/components/options-table/options-table.ts